import { render, staticRenderFns } from "./subtitle.vue?vue&type=template&id=985a1940&lang=pug"
import script from "./subtitle.vue?vue&type=script&lang=js"
export * from "./subtitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports